import { useSearchParams } from "react-router-dom";
import JiraTickets from "./jiraTickets";
import TicketDetails from "./jiraTicketDetails";

const UserSupport = () => {
  const [searchParams] = useSearchParams();
  const ticketId = searchParams.get("ticketId") || null;

  return ticketId ? <TicketDetails ticketId={ticketId} /> : <JiraTickets />;
};

export default UserSupport;
